import { render, staticRenderFns } from "./alipayDialog.vue?vue&type=template&id=c3a79b0e&scoped=true&"
import script from "./alipayDialog.vue?vue&type=script&lang=js&"
export * from "./alipayDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a79b0e",
  null
  
)

export default component.exports